import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import defaultConfig from "./config/index";

const connectionString = defaultConfig.appInsightsConnectionString;

if (connectionString) {
  const appInsights = new ApplicationInsights({
    config: {
      // https://learn.microsoft.com/en-us/azure/azure-monitor/app/javascript-sdk-configuration?tabs=javascriptwebsdkloaderscript
      connectionString,
      // If true, the SDK adds two headers ('Request-Id' and 'Request-Context') to all CORS requests to correlate outgoing AJAX dependencies with corresponding requests on the server side. Default is false
      enableCorsCorrelation: true,
      // Exclude third-party domains from CORS correlation headers to avoid CORS preflight failures
      correlationHeaderExcludedDomains: [
        '*.hubspot.com',
        '*.hsadspixel.net',
        '*.hs-scripts.com',
        '*.hs-analytics.net',
        '*.hscollectedforms.net',
        '*.hs-banner.com',
        '*.usemessages.com'
      ],
      // Automatically track route changes in Single Page Applications (SPA). If true, each route change sends a new Pageview to Application Insights. Hash route changes (example.com/foo#bar) are also recorded as new page views.
      // Note: If you enable this field, don't enable the history object for React router configuration because you get multiple page view events.
      // TODO: remove if we use react extension
      enableAutoRouteTracking: true,
      // When set to true, Fetch requests aren't automatically collected.
      disableFetchTracking: false,
      // If true, Ajax calls aren't autocollected (set to false for capturing axios calls)
      disableAjaxTracking: false,
      // If true, on a pageview, the previous instrumented page's view time is tracked and sent as telemetry and a new timer is started for the current pageview. It is sent as a custom metric named PageVisitTime in milliseconds and is calculated via the Date now() function.
      autoTrackPageVisitTime: true,
    },
  });

  appInsights.loadAppInsights();

  const ignoredDependencies: Array<{ target: string; path?: string }> = [
    { target: "google.com", path: "/rmkt/collect" },
    { target: "google.com", path: "/ccm/collect" },
    { target: "google.com", path: "/pagead/form-data" },
    { target: "google.com", path: "/ccm/form-data" },
    { target: "doubleclick.net" },
    { target: "googleadservices.com" },
    { target: "api.wire.threatspike.com" },
  ];

  appInsights.addTelemetryInitializer((item) => {
    if (item.baseType !== "RemoteDependencyData") return true;
    const data = item.baseData as { target?: string; name?: string; success?: boolean } | undefined;
    if (data?.success !== false) return true;
    const target = data.target ?? "";
    const name = data.name ?? "";
    return !ignoredDependencies.some(
      (rule) => target.includes(rule.target) && (!rule.path || name.includes(rule.path)),
    );
  });
} else {
  // eslint-disable-next-line no-console
  console.warn("Skipping AppInsights, no connection string found");
}
